export var MuiLink = {
    underline: 'always',
};
//# sourceMappingURL=MuiLink.js.map